import React from 'react';
import { Link } from 'react-router-dom';
import SubPage from '../components/site/SubPage';
import { PageSection, PageTitleBox } from '../components/site/SubPageParts';
import { ROUTES } from '../components/site/siteNav';

const CareersOpenRoles = () => (
  <SubPage title="Open Roles">
    <PageTitleBox>Open roles</PageTitleBox>

    <PageSection className="pt-8 pb-4">
      <div className="border border-black/25 px-6 py-12 text-center md:py-16">
        <p className="text-[22px] font-bold text-black md:text-[28px]">
          There are no positions currently available.
        </p>
        <p className="mx-auto mt-4 max-w-[52ch] text-[15px] leading-relaxed text-black md:text-[17px]">
          We&rsquo;re not hiring at the moment, but that changes. If you think stealing, abusing and
          cheating people is wrong &mdash; and you want to help stop it &mdash; check back here, or
          read more about the kind of people we look for.
        </p>
        <Link
          to={ROUTES.careers}
          className="mt-8 inline-block rounded-[8px] bg-[#2F5F9E] px-8 py-3 text-[16px] text-white transition-colors hover:bg-[#27508a] md:text-[18px]"
        >
          About working here
        </Link>
      </div>
    </PageSection>
  </SubPage>
);

export default CareersOpenRoles;
